import { h } from 'vue';

let waitForRecaptcha;

function ensureCaptchaIsLoaded() {
  if (window.__recaptchaLoaded) { // eslint-disable-line
    return;
  }

  waitForRecaptcha = new Promise((resolve) => {
    window.__recaptchaLoaded = () => resolve(window.grecaptcha);  // eslint-disable-line
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.google.com/recaptcha/api.js?onload=__recaptchaLoaded&render=explicit';
  (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
}

export default {
  props: {
    sitekey: {
      type: String,
      default: import.meta.env.VITE_RECAPTCHA_KEY,
    },
    theme: {
      type: String,
    },
    badge: {
      type: String,
    },
    type: {
      type: String,
    },
    size: {
      type: String,
    },
    tabindex: {
      type: String,
    },
  },
  data: () => ({
    widgetId: -1,
  }),
  methods: {
    call(method, ...args) {
      return waitForRecaptcha
        .then((captcha) => captcha[method](...args));
    },
    reset() {
      return this.call('reset', this.widgetId);
    },
    execute() {
      return this.call('execute', this.widgetId);
    },
    emitVerify(response) {
      this.$emit('verify', response);
      this.$emit('change', true);
    },
    emitExpired() {
      this.$emit('expired');
      this.$emit('change', false);
    },
  },
  beforeCreate() {
    ensureCaptchaIsLoaded();
  },
  mounted() {
    const opts = {
      ...this.$props,
      hl: this.$i18n.locale,
      callback: this.emitVerify,
      'expired-callback': this.emitExpired,
    };
    const container = this.$slots.default ? this.$el.children[0] : this.$el;
    this.call('render', container, opts)
      .then((id) => this.widgetId = id);
  },

  render() {
    return h('div', this.$slots.default);
  },
};
